import { Row, Col, Button, Spinner } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import { useNavigate } from "react-router-dom";
import { useLayoutEffect } from 'react';
// Import useNavigate
import ViewMoreIcon from "../../assets/right-arrow.svg";
import BannerImage from "../../assets/cmc.jpg";

import axios from "../../network/api";
import { useState, useEffect } from "react";
import { baseUrl } from "../../network/Constants";

import "./Blog.css";

function ViewMoreBlog() {
  const [blogs, setBlogs] = useState([]);
  const navigate = useNavigate(); // Initialize useNavigate
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchBlogs();
  }, []);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fetchBlogs = () => {
    setLoading(true);
    axios
      .get(baseUrl + "/app/blog/")
      .then((response) => {
        setBlogs(response.data);
        setLoading(false);
        console.log("Blogs:", JSON.stringify(response.data));
        
        // Also scroll to top after data is loaded
        setTimeout(() => {
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }, 100);
      })
      .catch((error) => {
        console.log("Error fetching blogs:", error);
        setLoading(false);
      });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    }).format(date);
  };

  return (
    <section className="blog" id="blog">
      <Container>
        <div className="blog-content">
          <div className="section-title pt-5">Blog</div>
          {loading ? (
            <div className="loader">
              <Spinner className="loading-color" />
            </div>
          ) : (
            <Row className="blog-row">
              {blogs.map((item, index) => (
                <Col
                  lg={4}
                  className="blog-image pt-3"
                  key={index}
                  onClick={() =>
                    navigate(`/blog-details/`, { state: { blog: item } })
                  }
                  style={{ cursor: "pointer" }} // Make it look clickable
                >
                  <div className="blog-post">
                    <img
                      src={item.image}
                      alt="Blog Image"
                      className="img-fluid"
                    />
                    <div className="blog-title py-3">{item.title}</div>
                    <div className="blog-content py-2">{item.content}</div>
                    <div className="blog-author pt-4">{item.author_name}</div>
                    <div className="blog-date">{formatDate(item.created_at)}</div>
                  </div>
                </Col>
              ))}
            </Row>
          )}
        </div>
      </Container>
    </section>
  );
}

export default ViewMoreBlog;